<template>
	<div class="pages">
		<div v-if="isIndex">
			<el-carousel :interval="8000" arrow="always" height="570px" style="width: 100%;">
			    <el-carousel-item v-for="item in bannerImg" :key="item">
			        <img
					  @click="gotodetail(1)"
			          style="width: 100%;"
			          :src="item" />
			    </el-carousel-item>
			</el-carousel>
			<div class="content">
				<div class="tips">
					<img class="tips-img1"  src="http://img.static.knnnj.com/Default/7c3fad4f-d964-4007-ac79-9ab4ee1eae4c.png" />
				</div>
				<div class="product">
					<div class="product-item" v-for="(item,i) in product" :key="i">
                        <el-card shadow="hover" style="border: 0rem;height: 30.25rem;">
                          <div class="product-img">
                          	<img :src="item.src" />
                          </div>
                          <div style="margin: 0 auto;width: 100%; display: flex; align-items: center; flex-direction: column;">
							  <div class="product-tips" style="text-align: left;">
							  	<span>{{item.tips}}</span>
							  </div>
							  <div class="product-content" style="text-align: left; height: 3.125rem;">
							  	<span>{{item.content}}</span>
							  </div>
						  </div>
						  <div class="buy" @click="showOrCode(i)">立即购买</div>
                        </el-card>
					</div>
				</div>
			</div>
			<div class="culture">
				<img src="http://img.static.knnnj.com/Default/e823879c-bf98-4e53-bf1c-77b6866a1730.png" />
			</div>
			<div class="content">
				<div class="tips">
					<img class="tips-img2"  src="http://img.static.knnnj.com/Default/5a38dd26-aaff-4898-80ec-c38c9c0ad85b.png" />
				</div>
				<div class="product">
					<el-card shadow="hover" style="border: 0rem;">
						<img @click="gotodetail(2)" class="activity-img"  src="http://img.static.knnnj.com/Default/7ced3554-a670-4fca-bd2e-6ce3807904f1.png" />
					</el-card>
					<el-card shadow="hover" style="margin-left: 0.9375rem;border: 0rem;">
						<img @click="gotodetail(3)" class="activity-img"  src="http://img.static.knnnj.com/Default/df526f16-6d1a-44c1-81c4-d8cc28ef9f17.png" />
					</el-card>
					<el-card shadow="hover" style="margin-left: 0.9375rem;border: 0rem;">
						<img @click="gotodetail(4)" class="activity-img"  src="http://img.static.knnnj.com/Default/d45687c0-f7cf-400d-b37a-b687d5cd03c1.png" />
					</el-card>
				</div>
				<div class="product" style="margin-top: 1.25rem;">
					<el-card shadow="hover" style="border: 0rem;">
					    <img @click="gotodetail(1)" class="activity-img"  src="http://img.static.knnnj.com/Default/0524cf53-dbdb-48d2-9c0b-5d6b16359f90.png" />
					</el-card>
					<el-card shadow="hover" style="margin-left: 0.9375rem;border: 0rem;">
					    <img @click="gotodetail(5)" class="activity-img"  src="http://img.static.knnnj.com/Default/a9482a72-8cf1-4923-9986-79d4f0010e71.png" />
					</el-card>
					<el-card shadow="hover" style="margin-left: 0.9375rem;border: 0rem;">
						<img @click="gotodetail(6)" class="activity-img"  src="http://img.static.knnnj.com/Default/e50fdf36-3a12-4d70-847f-1e951f770fe0.png" />
					</el-card>
				</div>
			</div>
			<div class="content">
				<div class="tips">
					<img class="tips-img3"  src="http://img.static.knnnj.com/Default/2bad01e3-8a7c-43d1-9861-47b9eecbf76c.png" />
				</div>
				<div class="develop">
					<div class="develop-img">
						<img src="http://img.static.knnnj.com/Default/5e6056a0-de8e-43c8-864a-d18c5128c91c.png" />
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="app"><!--@click="gotodetail(7)"-->
				   <div class="btn-group">
					   <div class="btn-item" @click="goShowAppaly">
						   <div style="display: flex; align-items: center;">
							   <img src="./assets/image4.png" style="width: 40px; height: 40px;"/>
							   <p>苹果客户端下载</p>
						   </div>
					   </div>
					   <div class="btn-item" @click="goShowAndroid">
						   <div style="display: flex; align-items: center;">
							   <img src="./assets/image5.png" style="width: 40px; height: 40px;"/>
							   <p>安卓客户端下载</p>
						   </div>
					   </div>
				   </div>
				</div>
				<div class="footer-div address">
					<span>福建松辉医药有限公司惠安分公司</span>
					<span style="margin-left: 22.5625rem;">公司地址</span>
				</div>
				<div class="footer-div" style="margin-top: 0.625rem;">
					<div class="slogan">
						<span>诚信为本，心怀敬畏</span>
						<span>创新求变，行稳致远</span>
						<span>合作共赢，价值共享</span>
					</div>
					<div class="addressInfo">
						<span>福建省泉州市惠安县辋川镇后许村 后许422-8号店面</span>
					</div>
				</div>
				<div class="footer-div">
					<span class="tel-text">欢迎致电</span>
					<span class="tel-number">0595-87819781</span>
				</div>
				<div class="registration">
					<span>网站备案号：闽ICP备2021000831号-1</span>
				</div>
			</div>
		</div>
		<detail :selectType="tapNum" v-if="isDetail"></detail>
		<!--二维码图的展示-->
		<div v-for="(item,index) in orCord" :key="index">
			<el-dialog
			  :visible.sync="item.isShowOrCode"
			  width="25%"
			  >
			  <div class="iamge">
				   <img :src="item.image" class="img"/>
			  </div>
			  <div class="orCord">
				  <div class="name">{{ item.name }}</div>
				  <div class="price">￥{{ item.price }}</div>
				  <div style="font-size: 1rem; color: #999999;">打开微信扫一扫进行购买</div>
			  </div>
			</el-dialog>
		</div>
		<!--显示安卓-->
		<el-dialog
		  :visible.sync="isShowAndroid"
		  width="25%"
		  >
		  <div class="iamge1">
			   <img src="http://img.static.knnnj.com/Default/3a8d3c57-9865-4ea6-b027-29e7c02b89e4.png" class="img"/>
			   <p style="width: 100%; text-align: center; font-size: 1.25rem; margin-top: 5px;">安卓客户端</p>
		  </div>
		</el-dialog>
		<!--显示苹果-->
		<el-dialog
		  :visible.sync="isShowAppaly"
		  width="25%"
		  >
		  <div class="iamge1">
			   <img src="http://img.static.knnnj.com/Default/3a8d3c57-9865-4ea6-b027-29e7c02b89e4.png" class="img"/>
			   <p style="width: 100%; text-align: center; font-size: 1.25rem; margin-top: 5px;">苹果客户端</p>
		  </div>
		</el-dialog>
	</div>	
</template>

<script>
	import detail from './views/detail.vue'
	export default {
	    name: 'app',
	    components: { detail },
        data() {
            return {
		        bannerImg: [
					'http://img.static.knnnj.com/Default/16033c57-00bb-4237-92ff-378ebc3f2500.png',
					'http://img.static.knnnj.com/Default/9553ed60-4391-4794-ae1d-6a0d463a2a27.png'
				],
				product: [
					{
						src: 'http://img.static.knnnj.com/Default/785ddfc5-5cea-4aa4-86f5-4c0042cea9cc.png',
						tips: '熊胆胶囊',
						content: '主要成分：熊胆粉，添加少量辅助用药，如淀粉、滑石粉。装于2号明胶空心胶囊壳中。'
					},
					{
						src: 'http://img.static.knnnj.com/Default/de348761-6160-48ea-9bf3-c768e189674d.jpg',
						tips: '熊胆粉',
						content: '护肝降酶、利胆、溶胆结石、降脂、抗脂肪肝、抗纤维化。'
					},
					{
						src: 'http://img.static.knnnj.com/Default/209b1311-f062-4880-8dcc-0c90bc6c9952.jpg',
						tips: '归真力酒',
						content: '精选上等白酒搭配珍贵中药材研酿5年,成就归真力酒'
					}
				],
				isIndex: true,
				isDetail: false,
				index: 0,
				tapNum: 1,
				isShowAppaly: false,
				isShowAndroid: false,
				orCord: [
					{
						name:'熊胆胶囊',
						price: 3998.00,
						image: 'http://img.static.knnnj.com/Default/c32ab21e-ade2-45c9-81e8-79a2d501c6ec.jpeg',
						isShowOrCode: false
					},
					{
						name:'熊胆粉',
						price: 3998.00,
						isShowOrCode: false,
						image: 'http://img.static.knnnj.com/Default/69775ab3-d3fc-436f-83a6-9d5dc15cb17b.jpeg'
					},
					{
						name:'归真力酒',
						price: 3998.00,
						image: 'http://img.static.knnnj.com/Default/d685c0b6-213c-4bdb-ad3c-c9d7288aea00.jpeg',
						isShowOrCode: false
					}
				]
	        }
	    },
		methods:{
		    gotodetail(value,i){
		        //指定跳转地址
		        this.isDetail = true
				this.isIndex = false
				this.tapNum = value
				this.index = i
			},
			backIndex() {
				this.isIndex = true
				this.isDetail = false
			},
			// 控制弹窗的关闭
			showOrCode(index){
				console.log(index)
				this.orCord[index].isShowOrCode = true
			},
			goShowAppaly(){
				this.isShowAppaly = true
			},
			goShowAndroid(){
				this.isShowAndroid = true
			}
        }
    }
</script>

<style>
	body {
		margin: 0;
	}
	
	.pages {
		background-color: #FFFFFF;
		width: 100%;
	}
	
	.content {
		justify-content: center;
		margin-top: 3.75rem;
	}
	
	.tips {
		justify-content: center;
		display: flex;	
	}
	
	.tips-img1 {
		width: 17.125rem;
		height: 4.1875rem;
		/* width: 100%; */
	}
	
	.tips-img2 {
		width: 21.4375rem;
		height: 4.125rem;
	}
	
	.tips-img3 {
		width: 21.4375rem;
		height: 3.75rem;
	}
	
	.product {
		width: 60%;
		justify-content: center;
		display: flex;
		margin: 0 auto;
		margin-top: 2.6875rem;
	}
	
	.product-item {
		width: 33.3%;
		justify-content: flex-start;
		margin-left: 1.25rem;
	}
	
	.product-img {
		width: 16.875rem;
		margin: 0 auto;
	}
	.product-img img{
		width: 100%;
		height: 100%;
	}
	.product-tips {
		margin: 1.875rem 0.625rem 0 0.625rem;
		width: 15.625rem;
		height: 1.375rem;
		font-size: 1rem;
		font-weight: 600;
		color: #4A4A4A;
		line-height: 1.375rem;
	}
	
	.product-content {
		margin: 0.625rem 0.625rem 0 0.625rem;
		width: 16.25rem;
		font-size: 0.8125rem;
		font-weight: 500;
		color: #9B9B9B;
	}
	
	.culture {
		width: 100%;
		/* height: 20rem; */
		margin-top: 3.75rem;
	}
	.culture img{
		width: 100%;
	}
	.activity-img {
		/* width: 23.75rem;
		height: 17.625rem; */
		width: 100%;
	}
	
	.develop {
		display: flex;
		justify-content: center;
		margin-top: 3.75rem;
	}
	
		
	.develop-img {
		width: 72.9375rem;
		height: 37.25rem;
	}
	
	.footer {
		/* width: 120rem; */
		width: 100%;
		height: 56.25rem ;
		margin-top: 9.375rem;
		background-color: #EFC16C;
	}
	
	.app {
		position: relative;
		width: 100%;
		height: 32.5rem;
		background: url("http://img.static.knnnj.com/Default/e60796ba-376f-4939-9e39-86e0807fab2a.png") no-repeat;
		background-size: 100% 100%;
	}
	.btn-group{
		width: 16.625rem;
		height: 8.25rem;
		position: absolute;
		left: 37.0625rem;
		top: 17.5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}
	.btn-item{
		width: 16.625rem;
		height: 3.125rem;
		display: flex;
		font-size: 1.25rem;
		color: #EFC16C;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		border-radius: 2.5rem;
	}
	/* .app img{
		width: 100%;
	} */
	.footer-div {
		/* margin-left: 29.125rem; */
		margin-left: 28.128rem;
		font-family: PingFangSC-Medium, PingFang SC;
		color: #FFFFFF;
		display: flex;
	}
	
	.address {
		/* margin-top: 6.25rem; */
		margin-top: 1.875rem;
		height: 2.5rem;
		font-size: 1.75rem;
		font-weight: 500;
		line-height: 2.5rem;
	}
	
	.slogan {
		width: 10rem;
		height: 1.5rem;
		font-size: 1.0625rem;
		font-weight: 500;
		line-height: 1.5rem;
	}
	
	.addressInfo {
		width: 16.5rem;
		height: 4.5rem;
		font-size: 1.0625rem;
		font-weight: 500;
		line-height: 1.5rem;
		margin-left: 38.875rem;
	}
	
	.tel-text {
		width: 6.125rem;
		height: 2.3125rem;
		font-size: 1.25rem;
		font-weight: 500;
		line-height: 2.3125rem;
		margin-top: 0.625rem;
	}
	
	.tel-number {
		width: 12.5rem;
		height: 2.3125rem;
		font-size: 1.625rem;
		font-weight: 500;
		line-height: 2.3125rem;
		margin-top: 0.625rem;
	}
	
	.registration {
		display: flex;
		justify-content: center;
		font-size: 1.375rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-top: 1.875rem;
	}
	.buy{
		margin: auto;
		margin-top: 1.25rem;
		width: 10.375rem;
		height: 2.5rem;
		background-color: rgb(255,237,237);
		border: 1px solid #ff0000;
		color: rgb(255,96,96);
		line-height: 40px;
		text-align: center;
		font-size:20px ;
		font-weight: 800;
	}
	.el-dialog{
		border: .625rem;
		height: 32.5rem;
		border-radius: 10px;
	}
	.el-dialog__body{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 92%;
		height: 85%;
	}
	.orCord{
		width: 100%;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.iamge{
		width: 320px;
		height: 330px;
	}
	.iamge1{
		width: 380px;
		height: 390px;
	}
	.img{
		width: 100%;
		/* height: 100%; */
	}
	.name{
		font-size: 1.5rem;
		color: #333333;
	}
	.price{
		font-size: 1.5rem;
		color: #333333;
		font-weight: bolder;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue